export default __webpack_public_path__ + "static/media/frg--sales-display.f946b012.png";